/* (ignored) */


//////////////////
// WEBPACK FOOTER
// supports-color (ignored)
// module id = 1870
// module chunks = 1